import ApiClient from '../ApiClient';

class AssistantBulkActions extends ApiClient {
  constructor() {
    super('assistant/bulk_actions', { accountScoped: true });
  }
}

export default new AssistantBulkActions();
